// Instance role compatibility for legacy UI permission and eligibility checks.
// Platform staff roles never imply Administrator eligibility here.
const normalizeRole = (value) => String(value || '').trim().toLowerCase().replace(/[_\s]+/g, '-');
const effectiveRoles = (role) => {
  const normalized = normalizeRole(role);
  if (normalized === 'super-administrator' || normalized === 'superadmin') return [normalized, 'administrator', 'admin'];
  if (normalized === 'administrator' || normalized === 'admin') return [normalized, 'administrator', 'admin'];
  return normalized ? [normalized] : [];
};
const hasRole = (role, expected) => effectiveRoles(role).includes(normalizeRole(expected));
const matchesAnyRole = (role, expectedRoles = []) => expectedRoles.some(expected => hasRole(role, expected));
const isAdministratorRole = (role) => hasRole(role, 'administrator');
module.exports = { normalizeRole, effectiveRoles, hasRole, matchesAnyRole, isAdministratorRole };
